import { Component, OnInit } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { AlertService } from '../../_services/alert.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { User } from '../../_models/user';
import { ActivatedRoute, Router } from "@angular/router";
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-ticket-view',
  templateUrl: './ticket-view.component.html',
  styleUrls: ['./ticket-view.component.scss'],
})
export class TicketViewComponent implements OnInit {
  viewTicket: any = {};
  ticketId: any;
  comments: string;
  details: string;
  companyName: string;
  contactName: string;
  mobile: string;
  email: string;
  value: any = [];
  commentsError: string;
  commentsList: any;
  today: number = Date.now();
  attachment: string;
  attachments: any;
  imageUrl: string;
  errorMessage: string;
  singleAttachment: any;

  constructor(private router: Router, private route: ActivatedRoute, public user: User, private http: HttpClient, private alertService: AlertService, private api: ApiIntegration, private g: Globals) {
    this.ticketId = this.route.snapshot.params['id'];
    this.getTicket();
  }

  addAttachment(event) {
    this.attachment = event.target.files[0];
  }

  getTicket() {
    this.g.loaderDisplay = "display";
    this.api.getSupportTicketById(this.ticketId,this.user.userId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.viewTicket = data;
      this.details = this.viewTicket.description.split('\n');
      this.singleAttachment = this.viewTicket.attachments;
      this.commentsList = this.viewTicket.comments;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  blurComments() {
    this.commentsError = "";
    if (!this.comments) {
      this.commentsError = "Please Enter Comments";
    }
  }

  getPdfMulty(nkasd) {
    console.log("nkasd::" + nkasd);
  }

  ngOnInit() {
  }

  submit() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createCommentsForTicket', {
      "accountOwnerId": this.user.accountOwnerId,
      "comments": this.comments,
      "organizationId": this.user.organizationId,
      "ticketId": this.viewTicket.sourceTicketId,
      "userId": this.user.userId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Success', data['message']);
          this.comments = "";
          this.attachment = "";
          this.getTicket();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  newApi() {
    this.g.loaderDisplay = "display";
    const file = this.attachment;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/addAttachment?organizationId=' + this.viewTicket.organizationId + "&ticketId=" + this.viewTicket.sourceTicketId, formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      //this.submit();
      if (data['code'] == 200) {
        this.attachments = data['href'];
        this.submit();
      } else {
        this.submit();
      }
    },
      (err: HttpErrorResponse) => {
        this.submit();
        this.g.loaderDisplay = "";
        this.errorMessage = "Upload Image Failed Please Re-try";
      });
  }

  getPdf(pdf) {
    var header1 = new HttpHeaders();
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.g.loaderDisplay = "display";
    this.http.post(environment.apiUrl + 'api/getAttachmentContent', {
      "contentUrl": pdf.href,
      "organizationId": this.user.organizationId,
    },
      { responseType: 'blob', headers: header1 }).subscribe((resp: any) => {
        console.log(resp);
        var mediaType = resp['type'];
        var blob = new Blob([resp], { type: mediaType });
        var filename = pdf.name;
        saveAs(blob, filename);
        this.g.loaderDisplay = "";
      },
        (err) => {
          this.g.loaderDisplay = "";
          this.alertService.error('Error', err);
        });
  }
}
